import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { ProfileButtonsProps } from "models/propTypes/businessUnitPropTypes";
import { AuthEnums, DialogEnums, StyleEnums } from "models/enums";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, useNavigationHistory } from "components/common";
import { useNavigate } from "react-router-dom";
import { EditSalaryButton } from "components/salary";
import { useEmployeeHelpers } from "components/employee";
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const CreateProfileButtons: React.FC<ProfileButtonsProps> = (props) => {
  const businessUnitService = useBusinessUnitService();
  const { businessUnit } = props;

  const navigate = useNavigate();
  const { goBack } = useNavigationHistory();
  const { canBulkEditSalaries, canCreate } = useEmployeeHelpers();

  const deleteBusinessUnit = () => {
    return businessUnitService.deleteBusinessUnit(businessUnit.id as string);
  };

  const goToSettingsAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.EditBusinessUnit)}`,
    icon: IconDefinitionConstants.WSettings,
    onClickHandler: async () => {
      navigate(UrlHelper.formatPath(`/BusinessUnits/${businessUnit.id}/Settings`));
    },
  };

  const deleteBusinessUnitAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.Delete),
    icon: IconDefinitionConstants.WTrashAlt,
    actionDialog: {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.DeleteQuestion),
      titleIcon: IconDefinitionConstants.WTimes,
      dialogType: DialogEnums.DialogType.Message,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          onClick: deleteBusinessUnit,
          type: StyleEnums.DisplayType.Danger,
          successMessage: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.Deleted),
        },
      ],
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.DeleteWarning),
      type: StyleEnums.DisplayType.Danger,
    },
    highlightType: StyleEnums.DisplayType.Danger,
    onActionSuccess: () =>
      setTimeout(() => {
        goBack();
      }, 100),
  };

  const addEmployeeAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddUser)}`,
    icon: IconDefinitionConstants.WUser,
    onClickHandler: async () => {
      navigate(UrlHelper.formatPath(`/Employee/Create`));
    },
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    actions.push(goToSettingsAction);
    if (canCreate) {
      actions.push(addEmployeeAction);
    }
    if (
      CompanyService.hasRelations([
        AuthEnums.PersonCompanyRelationType.Admin,
        AuthEnums.PersonCompanyRelationType.SalaryAdmin,
      ])
    ) {
      actions.push(deleteBusinessUnitAction);
    }
    return actions;
  };

  return (
    <DashboardButtonGroup
      buttons={(canBulkEditSalaries && businessUnit.managerHasSalaryRights
        ? [<EditSalaryButton />, ACTION_SEPARATOR as typeof ACTION_SEPARATOR]
        : []
      ).concat([<FilterButton />])}
      moreActions={getMenuItems()}
    ></DashboardButtonGroup>
  );
};

export default CreateProfileButtons;
